import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import './LanguageSelector.css'
import './LanguageSelector.css';
import { FiArrowUpRight } from 'react-icons/fi';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const options = [
  { value: 'pt-BR', label: 'Portuguese (Brasil)' },
];

const LanguageSelector = ({currentProject, darkMode}) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [closeLanguageSelector, setCloseLanguageSelector] = useState(true)
  const [fadeOutEffect, setFadeOutEffect] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: '200px',
      padding: '0',
      minHeight: '10px',
      fontSize: '12px',
      color: '#202020',
      ...(windowWidth <= 1024 && {
          width: '150px',
          fontSize: '10px'
      }),
      ...(windowWidth <= 320 && {
        width: '130px',
        fontSize: '8px'
    }),
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#4D4D4D' : 'transparent',
      color: state.isSelected ? '#fff' : 'inherit',
      fontSize: state.isSelected ? '12px' : 'inherit',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? '#fff' : 'inherit',
    }),
  };

  useEffect(() => {
    const handleResize = () => {
    setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
    window.removeEventListener('resize', handleResize);
    };
}, []);

  return (
      <>
        {closeLanguageSelector && (
          <div style={{display: currentProject || darkMode  ? 'none' : ''}} className={`${'container_selecte_language'} ${'sliderAnimation'} ${fadeOutEffect ? 'fadeOutEffect' : ''}`}>
            <p>Select one of the languages that suits you to see content specific to your location:</p>
            
              
          <div className='container_selecte_language_itens'>
            
          <Select
              options={options}
              value={selectedOption}
              onChange={handleChange}
              isSearchable={false}
              styles={selectStyles}
              className="select-box"
              classNamePrefix="select"
            />

            <Link id='selecte_language_link' to="/pt-br" className="language_selector_a" type="submit">
              Continue <FiArrowUpRight className="language_selector_icon" style={{ color: '#4d4d4d' }} />
            </Link>

            <button className="language_selector_a" onClick={() => {setFadeOutEffect(true) 
                                    setTimeout(() => {
                                      setCloseLanguageSelector(false)
                                    }, 2000);}}>
              Close <AiOutlineClose className="language_selector_icon" style={{ color: '#4d4d4d' }} />
            </button>
          </div>
        </div>
        )}
      </>
  );
};

export default LanguageSelector;